import React from 'react';
import { createSvgIcon } from './utils/createSvgIcon';
import { aibTheme } from '~/uikit/Theme/Theme';

const colors = aibTheme.palette;

export const IconClose = createSvgIcon(
  'close',
  <g>
    <path d="M18 6L6 18" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M6 6L18 18" strokeLinecap="round" strokeLinejoin="round" />
  </g>,
  24,
  24,
  colors.secondary.semilight,
  colors.neutral.baseWhite
);
